import React from 'react';
import PropTypes from 'prop-types';

import './AspectRatioCardText.less';

const AspectRatioCardText = ({ text }) => {
  return (
    <div className="AspectRatioCard__content">
      {text}
    </div>
  );
};

AspectRatioCardText.propTypes = {
  text: PropTypes.string.isRequired
};

AspectRatioCardText.defaultProps = {
  text: ''
};

export default AspectRatioCardText;
